<template>
  <form
    class="w-full shadow-sm flex opacity-25 active:opacity-100 hover:opacity-100" :style="terms && terms === $route.query.terms ? 'opacity: 100' : ''"
    @submit.prevent="submit()"
  >
    <input
      class="w-full rounded-l p-2 outline-none"
      type="text"
      placeholder="Search..."
      v-model="terms"
      required
    />
    <button
      class="bg-white w-auto flex justify-end items-center text-blue p-2 hover:text-blue-light rounded-r"
      type="submit"
    >
      <i class="material-icons">search</i>
    </button>
  </form>
</template>

<script>
import {mapActions} from "vuex";

export default {
    name: "Search",
    data() {
        return {
            terms: this.$route.query.terms
        };
    },
    methods: {
        submit() {
            this.search({terms: this.terms});
            this.$router.push({
                name: "KnowledgeSearch",
                query: { terms: this.terms }
            });
        },
        ... mapActions({"search": "knowledge/search/search"}),
    },
    mounted() {
        if (this.terms) {
            this.search({terms: this.terms});
        }
    }
};
</script>
